<template>
    <SvgIcon
        v-if="isStatisticsAvailable"
        v-tooltip:top="i18n.t('statistics_icon_tooltip')"
        v-gtm:label="'Statistics'"
        v-gtm:@click
        class="icon live-stream"
        name="icon-system-statistics"
        v-bind:size="size"
        v-on:click="openStatistics"
    />
</template>

<script lang="ts" setup>
    import { toRefs } from 'vue';
    import SvgIcon from '@/components/common/SvgIcon.vue';
    import { useStatistics } from '@/composable/useStatistics';
    import { i18n } from '@/core/lib/i18n';
    import type { IEvent, IEventEuro } from '@/interface/IEvent';

    const props = defineProps<{
        event: IEvent | IEventEuro;
        size?: string | number;
    }>();

    const { event } = toRefs(props);
    const { isStatisticsAvailable, openStatistics } = useStatistics(event);
</script>
